import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';
import metadataReducer from './reducers/metadata.slice';
import mediaReducer from './reducers/media.slice';
import tierReducer from './reducers/tier.slice';
import projectReducer from './reducers/project.slice';
import authReducer from './reducers/auth.slice';

const sagaMiddleware = createSagaMiddleware();
const devMode = process.env.NODE_ENV === 'development';

const rootReducer = {
  media: mediaReducer,
  metadata: metadataReducer,
  tier: tierReducer,
  project: projectReducer,
  auth: authReducer,
};

const store = configureStore({
  reducer: rootReducer,
  devTools: devMode,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
    sagaMiddleware,
  ],
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
